// 用户相关接口
const user = {
    login_sms: '/user/login/sms',              // 手机验证码登录
    user_info: '/user',                 // 获取用户信息
    update_password: '/user/update/password',
    update_institution: '/user/update/institution',
    update_nickname: '/user/update/nickname',
    update_phone: '/user/update/phone',
    login_phone: '/user/login/phone',
    draft_bg:'/user/draft-bg',
    delete_draft_bg: '/user/draft-bg/delete',
    bind_qq: '/user/binding/qq',
    get_provider: '/user/provider',
}
export default user; 